import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { CSSTransition } from 'react-transition-group';
import { getSolidBackgroundShade } from 'utils/ui/colors';
import Text from 'components/Text';
import Landmark from 'components/Landmark';
import ErrorBoundary from 'components/ErrorBoundary';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var LoaderBG = styled.div.withConfig({
  displayName: "ErrorAndLoadingWrapper__LoaderBG",
  componentId: "sc-s9qcfw-0"
})(function (_ref) {
  var theme = _ref.theme,
    transitionDuration = _ref.transitionDuration;
  return {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    background: getSolidBackgroundShade(theme),
    // TODO: make transitions and animations part of the theming
    transition: "opacity ".concat(transitionDuration, "ms ease-out"),
    '&.fade-enter': {
      opacity: 0
    },
    '&.fade-enter-active': {
      opacity: 1
    },
    '&.fade-enter-done': {
      opacity: 1
    },
    '&.fade-exit': {
      opacity: 1
    },
    '&.fade-exit-active': {
      opacity: 0
    },
    '&.fade-exit-done': {
      opacity: 0
    }
  };
});
var Overlay = function Overlay(_ref2) {
  var isVisible = _ref2.isVisible,
    _ref2$transitionDurat = _ref2.transitionDuration,
    transitionDuration = _ref2$transitionDurat === void 0 ? 200 : _ref2$transitionDurat,
    children = _ref2.children;
  return /*#__PURE__*/_jsx(CSSTransition, {
    unmountOnExit: true,
    in: isVisible,
    timeout: transitionDuration,
    classNames: "fade",
    children: /*#__PURE__*/_jsx(LoaderBG, {
      transitionDuration: transitionDuration,
      children: children
    })
  });
};
var Loader = function Loader(_ref3) {
  var isVisible = _ref3.isVisible;
  return /*#__PURE__*/_jsx(Overlay, {
    isVisible: isVisible,
    children: /*#__PURE__*/_jsx(Landmark, {
      icon: "spinner"
    })
  });
};
function Error(_ref4) {
  var error = _ref4.error;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _error$message = error.message,
    message = _error$message === void 0 ? t('error_generic') : _error$message,
    code = error.code;
  return /*#__PURE__*/_jsx(Overlay, {
    isVisible: !!error,
    children: /*#__PURE__*/_jsxs(Landmark, {
      icon: "flag",
      children: [/*#__PURE__*/_jsx("p", {
        children: message
      }), code && /*#__PURE__*/_jsxs(Text, {
        as: "p",
        mt: "m",
        children: [t('error_code'), ": ", /*#__PURE__*/_jsx("b", {
          children: error.code
        })]
      })]
    })
  });
}
function ErrorAndLoadingWrapper(_ref5) {
  var children = _ref5.children,
    error = _ref5.error,
    isReady = _ref5.isReady;
  return /*#__PURE__*/_jsxs(ErrorBoundary, {
    children: [/*#__PURE__*/_jsx(Loader, {
      isVisible: !error && !isReady
    }), error ? /*#__PURE__*/_jsx(Error, {
      error: error
    }) : children]
  });
}
export default ErrorAndLoadingWrapper;